import { toDisplayString as _toDisplayString, createVNode as _createVNode, resolveComponent as _resolveComponent, withModifiers as _withModifiers, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createSlots as _createSlots, Fragment as _Fragment, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-4be7a1ac")

_pushScopeId("data-v-4be7a1ac")
const _hoisted_1 = {
  class: "font-semibold text-gray-lp-300 text-16px text-left",
  "data-testid": "handover-failed-vendor-stt-modal-title"
}
const _hoisted_2 = { class: "flex items-center justify-between gap-x-2 w-full" }
const _hoisted_3 = {
  key: 0,
  class: "py-3 text-center"
}
const _hoisted_4 = {
  id: "handover-failed-vendor-sentinel",
  ref: "sentinel",
  "data-testid": "handover-failed-vendor-sentinel",
  class: "h-1"
}
const _hoisted_5 = { class: "flex justify-end" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_Icons = _resolveComponent("Icons")!
  const _component_TableV2 = _resolveComponent("TableV2")!
  const _component_Skeleton = _resolveComponent("Skeleton")!
  const _component_lp_button = _resolveComponent("lp-button")!
  const _component_ModalV2 = _resolveComponent("ModalV2")!
  const _component_Notification = _resolveComponent("Notification")!

  return (_openBlock(), _createBlock(_Fragment, null, [
    _createVNode(_component_ModalV2, {
      width: "w-1000px",
      onClose: _ctx.close,
      isCustomTitle: true,
      title: _ctx.title,
      titlePadding: "px-4 py-4",
      contentPadding: "px-4 pb-4",
      footerPadding: "px-4 py-4",
      footerBgColor: "bg-white",
      isShadows: false,
      closeButtonTestId: "handover-failed-vendor-stt-modal-close-x",
      "data-testid": "handover-failed-vendor-stt-modal",
      isRoundedLg: "",
      scrollable: false,
      showBorderTitle: false
    }, _createSlots({
      "custom-title": _withId(() => [
        _createVNode("div", _hoisted_1, _toDisplayString(_ctx.title), 1)
      ]),
      content: _withId(() => [
        _createVNode("div", {
          id: "handover-failed-vendor-scroll-container",
          ref: "scrollContainer",
          "data-testid": "handover-failed-vendor-scroll-container",
          class: "text-left max-h-[60vh] overflow-y-auto pb-4",
          onScrollPassive: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.onScroll && _ctx.onScroll(...args)))
        }, [
          _createVNode(_component_TableV2, {
            columns: _ctx.columns,
            data: _ctx.failedSttList,
            loading: _ctx.isLoadingInitial,
            pagination: _ctx.pagination,
            "onUpdate:pagination": _cache[1] || (_cache[1] = ($event: any) => (_ctx.pagination = $event)),
            isHardPagination: false,
            hidePagination: true,
            borderBottom: false,
            isDetailAble: false,
            "data-testid": "handover-failed-vendor-stt-table",
            isNoPaddingBottom: "",
            pinnedSubstractHeight: "300px",
            bgHeader: "bg-white",
            isSpaceTop: false
          }, {
            reason: _withId(({ item }) => [
              _createVNode("div", _hoisted_2, [
                _createVNode("div", {
                  class: "line-clamp-5 text-left text-black-lp-300 break-words whitespace-normal flex-1",
                  style: {"display":"-webkit-box","-webkit-box-orient":"vertical","-webkit-line-clamp":"5","overflow":"hidden","text-overflow":"ellipsis"},
                  title: _ctx.isForeignAccount ? item.reasonEn : item.reason,
                  "data-testid": "handover-failed-vendor-stt-reason-text"
                }, _toDisplayString(_ctx.isForeignAccount ? item.reasonEn : item.reason), 9, ["title"]),
                _createVNode("div", {
                  class: "flex-shrink-0 cursor-pointer pt-0.5 text-red-lp-100 hover:text-red-lp-200",
                  "data-testid": "handover-failed-vendor-copy-reason",
                  onClick: _withModifiers(($event: any) => (
                  _ctx.copyReason(_ctx.isForeignAccount ? item.reasonEn : item.reason)
                ), ["stop"])
                }, [
                  _createVNode(_component_Icons, {
                    name: "copy-clipboard",
                    class: "w-4 h-4"
                  })
                ], 8, ["onClick"])
              ])
            ]),
            _: 1
          }, 8, ["columns", "data", "loading", "pagination"]),
          (_ctx.isLoadingMore)
            ? (_openBlock(), _createBlock("div", _hoisted_3, [
                _createVNode(_component_Skeleton, {
                  height: "1.3rem",
                  class: "my-1"
                }),
                _createVNode(_component_Skeleton, {
                  height: "1.3rem",
                  class: "my-1"
                })
              ]))
            : _createCommentVNode("", true),
          _createVNode("div", _hoisted_4, null, 512)
        ], 544)
      ]),
      _: 2
    }, [
      (_ctx.eligibleRetry)
        ? {
            name: "footer",
            fn: _withId(() => [
              _createVNode("div", _hoisted_5, [
                _createVNode(_component_lp_button, {
                  title: _ctx.translate('handover.list.retry.menu'),
                  textColor: "white",
                  iconLeft: "ics_o_reload",
                  color: "red-lp-2400",
                  onClick: _ctx.retry,
                  "data-testid": "handover-failed-vendor-stt-modal-close"
                }, null, 8, ["title", "onClick"])
              ])
            ])
          }
        : undefined
    ]), 1032, ["onClose", "title"]),
    _createVNode(_component_Notification, {
      modelValue: _ctx.isCopied,
      "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_ctx.isCopied = $event)),
      isCustom: "",
      message: _ctx.copyStyles.message,
      customStyles: _ctx.copyStyles,
      isAutoDisplay: false,
      isAutoClose: "",
      timeout: 3,
      class: _ctx.copyStyles.width,
      showIconClose: false
    }, null, 8, ["modelValue", "message", "customStyles", "class"])
  ], 64))
})